import React, { HTMLAttributes } from 'react'
import ReactTooltip from 'react-tooltip'
import styled from 'styled-components'
import Icon from '@icons/tooltip.inline.svg'

export interface ITooltip {
  place?: 'top' | 'right' | 'bottom' | 'left'
}

const SIcon = styled(Icon)`
  outline: none;
`

const STooltip = styled(ReactTooltip)`
  background: white;
  opacity: 1 !important;
  border-radius: ${({ theme }) => theme.general.borderRadius};
  box-shadow: ${({ theme }) => theme.general.boxShadow};
  &:before {
    opacity: 0 !important;
  }
`

const Tooltip: React.FC<HTMLAttributes<SVGElement> & ITooltip> = ({ id, children, place, ...rest }) => {
  return (
    <>
      <SIcon {...rest} data-tip data-for={id} />
      <STooltip id={id} effect="solid" place={place}>
        {children}
      </STooltip>
    </>
  )
}

export default Tooltip
